<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.addEventListener('scroll', this.scrollFn, { passive: true })
    this.scrollFn()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollFn)
  },
  methods: {
    scrollFn() {
      let header = document.getElementById('header')
      if (!header) return
      if (window.scrollY > 24) {
        header.classList.add('header-fixed')
      } else {
        header.classList.remove('header-fixed')
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue